const s = {
  custom: "",
  today: "Today",
  yesterday: "Yesterday",
  last7Days: "Last 7 days",
  last30Days: "Last 30 days",
  lastMonth: "Last Month",
  thisMonth: "This Month",
  thisWeek: "This Week",
  lastWeek: "Last Week"
};
export {
  s as periodLabelMap
};
//# sourceMappingURL=periodLabelMap.js.map
